// This file was autogenerated, don't edit it manually.
// Use `make regenerate-frontend` in {REPOSITORY_ROOT}/core directory.
import { Permission } from 'lib/enum/permission.enum';

export const Roles = [
    {
        id: 'mrwork_admin',
        displayName: 'MrWork Admin',
        hierarchyRank: 0,
        employeeRole: true,
        cascading: false,
        permissions: [
            Permission.accessControlManagePeers,
            Permission.adsConnectionsManage,
            Permission.adsConnectionsView,
            Permission.agentsManage,
            Permission.agentsView,
            Permission.auditView,
            Permission.backstageAccess,
            Permission.birdProxyRead,
            Permission.birdProxyWrite,
            Permission.brandsAudienceCreate,
            Permission.brandsAudienceEdit,
            Permission.brandsCampaignDraftsManage,
            Permission.brandsCampaignsManage,
            Permission.budgetsManage,
            Permission.businessAccountEmployeeMembersManage,
            Permission.businessAccountMembersAdd,
            Permission.businessAccountMembersManage,
            Permission.businessAccountMembersView,
            Permission.businessAccountSalesforceAccountIdEdit,
            Permission.businessAccountsCustomize,
            Permission.businessAccountsManage,
            Permission.businessAccountsView,
            Permission.channelStrategiesManage,
            Permission.channelStrategiesView,
            Permission.channelsManage,
            Permission.contentLibraryManage,
            Permission.contentLibraryView,
            Permission.emailChannelsManage,
            Permission.employeeFeaturesAccess,
            Permission.employeesManage,
            Permission.experimentalFeaturesAccess,
            Permission.googleAnalyticsEventMappingManage,
            Permission.importerRun,
            Permission.jobCampaignAdvertisementsManage,
            Permission.jobCampaignDraftAdvertisementsManage,
            Permission.jobCampaignDraftsManage,
            Permission.jobCampaignsManage,
            Permission.jobylonManageAllTalents,
            Permission.jobylonManageSettings,
            Permission.jobylonManageSingleTalents,
            Permission.komboIntegrationsManage,
            Permission.leadsAutomationsManage,
            Permission.leadsCustomFieldsManage,
            Permission.leadsGeneralSettingsManage,
            Permission.leadsJourneyAutomationsManage,
            Permission.leadsJourneysManage,
            Permission.leadsTalentpoolsManage,
            Permission.linkedinCredentialsManage,
            Permission.microserviceProxyAccess,
            Permission.otysConnectionsManage,
            Permission.productItemRolesManage,
            Permission.productItemsManage,
            Permission.productItemsView,
            Permission.productRolesManage,
            Permission.productUtmSettingsManage,
            Permission.productsView,
            Permission.rolesEdit,
            Permission.socialCampaignsManage,
            Permission.ssoConnectionsManage,
            Permission.ssoConnectionsView,
            Permission.ssoSettingsManage,
            Permission.supermetricsConnectionsManage,
            Permission.talentStatusesManage,
            Permission.talentsManage,
            Permission.talentsRemove,
            Permission.usersApiKeyManage,
            Permission.usersEditProfile,
            Permission.usersViewAll,
            Permission.websiteWidgetManage,
            Permission.websiteWidgetsView,
        ],
    },
    {
        id: 'mrwork_user',
        displayName: 'MrWork User',
        hierarchyRank: 20,
        employeeRole: true,
        cascading: false,
        permissions: [
            Permission.adsConnectionsManage,
            Permission.adsConnectionsView,
            Permission.agentsManage,
            Permission.agentsView,
            Permission.auditView,
            Permission.backstageAccess,
            Permission.birdProxyRead,
            Permission.birdProxyWrite,
            Permission.brandsAudienceCreate,
            Permission.brandsAudienceEdit,
            Permission.brandsCampaignDraftsManage,
            Permission.brandsCampaignsManage,
            Permission.budgetsManage,
            Permission.businessAccountMembersAdd,
            Permission.businessAccountMembersManage,
            Permission.businessAccountMembersView,
            Permission.businessAccountsCustomize,
            Permission.businessAccountsManage,
            Permission.businessAccountsView,
            Permission.channelStrategiesManage,
            Permission.channelStrategiesView,
            Permission.channelsManage,
            Permission.contentLibraryManage,
            Permission.contentLibraryView,
            Permission.emailChannelsManage,
            Permission.employeeFeaturesAccess,
            Permission.googleAnalyticsEventMappingManage,
            Permission.importerRun,
            Permission.jobCampaignAdvertisementsManage,
            Permission.jobCampaignDraftAdvertisementsManage,
            Permission.jobCampaignDraftsManage,
            Permission.jobCampaignsManage,
            Permission.jobylonManageAllTalents,
            Permission.jobylonManageSettings,
            Permission.jobylonManageSingleTalents,
            Permission.komboIntegrationsManage,
            Permission.leadsAutomationsManage,
            Permission.leadsCustomFieldsManage,
            Permission.leadsGeneralSettingsManage,
            Permission.leadsJourneyAutomationsManage,
            Permission.leadsJourneysManage,
            Permission.leadsTalentpoolsManage,
            Permission.microserviceProxyAccess,
            Permission.otysConnectionsManage,
            Permission.productItemRolesManage,
            Permission.productItemsManage,
            Permission.productItemsView,
            Permission.productRolesManage,
            Permission.productUtmSettingsManage,
            Permission.productsView,
            Permission.socialCampaignsManage,
            Permission.ssoConnectionsView,
            Permission.supermetricsConnectionsManage,
            Permission.talentStatusesManage,
            Permission.talentsManage,
            Permission.talentsRemove,
            Permission.usersEditProfile,
            Permission.usersViewAll,
            Permission.websiteWidgetManage,
            Permission.websiteWidgetsView,
        ],
    },
    {
        id: 'administrator',
        displayName: 'Administrator',
        hierarchyRank: 100,
        employeeRole: false,
        cascading: false,
        permissions: [
            Permission.accessControlManagePeers,
            Permission.adsConnectionsView,
            Permission.agentsManage,
            Permission.agentsView,
            Permission.birdProxyRead,
            Permission.birdProxyWrite,
            Permission.brandsAudienceEdit,
            Permission.brandsCampaignDraftsManage,
            Permission.brandsCampaignsManage,
            Permission.businessAccountMembersManage,
            Permission.businessAccountMembersView,
            Permission.businessAccountsCustomize,
            Permission.businessAccountsView,
            Permission.channelStrategiesManage,
            Permission.channelStrategiesView,
            Permission.channelsManage,
            Permission.contentLibraryManage,
            Permission.contentLibraryView,
            Permission.emailChannelsManage,
            Permission.googleAnalyticsEventMappingManage,
            Permission.importerRun,
            Permission.jobCampaignAdvertisementsManage,
            Permission.jobCampaignDraftAdvertisementsManage,
            Permission.jobCampaignDraftsManage,
            Permission.jobCampaignsManage,
            Permission.jobylonManageAllTalents,
            Permission.jobylonManageSettings,
            Permission.jobylonManageSingleTalents,
            Permission.komboIntegrationsManage,
            Permission.leadsAutomationsManage,
            Permission.leadsCustomFieldsManage,
            Permission.leadsGeneralSettingsManage,
            Permission.leadsJourneyAutomationsManage,
            Permission.leadsJourneysManage,
            Permission.leadsTalentpoolsManage,
            Permission.microserviceProxyAccess,
            Permission.otysConnectionsManage,
            Permission.productItemRolesManage,
            Permission.productItemsManage,
            Permission.productItemsView,
            Permission.productRolesManage,
            Permission.productUtmSettingsManage,
            Permission.productsView,
            Permission.supermetricsConnectionsManage,
            Permission.talentStatusesManage,
            Permission.talentsManage,
            Permission.talentsRemove,
            Permission.websiteWidgetManage,
            Permission.websiteWidgetsView,
        ],
    },
    {
        id: 'manager',
        displayName: 'Manager',
        hierarchyRank: 120,
        employeeRole: false,
        cascading: false,
        permissions: [
            Permission.adsConnectionsView,
            Permission.agentsManage,
            Permission.agentsView,
            Permission.birdProxyRead,
            Permission.birdProxyWrite,
            Permission.brandsAudienceEdit,
            Permission.brandsCampaignDraftsManage,
            Permission.brandsCampaignsManage,
            Permission.businessAccountMembersManage,
            Permission.businessAccountMembersView,
            Permission.businessAccountsCustomize,
            Permission.businessAccountsView,
            Permission.channelStrategiesManage,
            Permission.channelStrategiesView,
            Permission.channelsManage,
            Permission.contentLibraryManage,
            Permission.contentLibraryView,
            Permission.emailChannelsManage,
            Permission.googleAnalyticsEventMappingManage,
            Permission.importerRun,
            Permission.jobCampaignAdvertisementsManage,
            Permission.jobCampaignDraftAdvertisementsManage,
            Permission.jobCampaignDraftsManage,
            Permission.jobCampaignsManage,
            Permission.jobylonManageSingleTalents,
            Permission.leadsAutomationsManage,
            Permission.leadsCustomFieldsManage,
            Permission.leadsGeneralSettingsManage,
            Permission.leadsJourneyAutomationsManage,
            Permission.leadsJourneysManage,
            Permission.leadsTalentpoolsManage,
            Permission.microserviceProxyAccess,
            Permission.otysConnectionsManage,
            Permission.productItemRolesManage,
            Permission.productItemsManage,
            Permission.productItemsView,
            Permission.productRolesManage,
            Permission.productUtmSettingsManage,
            Permission.productsView,
            Permission.supermetricsConnectionsManage,
            Permission.talentStatusesManage,
            Permission.talentsManage,
            Permission.talentsRemove,
            Permission.websiteWidgetManage,
            Permission.websiteWidgetsView,
        ],
    },
    {
        id: 'recruiter',
        displayName: 'Recruiter',
        hierarchyRank: 125,
        employeeRole: false,
        cascading: false,
        permissions: [
            Permission.agentsView,
            Permission.birdProxyRead,
            Permission.birdProxyWrite,
            Permission.businessAccountMembersView,
            Permission.businessAccountsView,
            Permission.contentLibraryView,
            Permission.jobylonManageAllTalents,
            Permission.jobylonManageSingleTalents,
            Permission.leadsJourneyAutomationsManage,
            Permission.leadsTalentpoolsManage,
            Permission.microserviceProxyAccess,
            Permission.productItemsView,
            Permission.productsView,
            Permission.talentsManage,
            Permission.talentsRemove,
            Permission.websiteWidgetsView,
        ],
    },
    {
        id: 'campaign_manager',
        displayName: 'Campaign Manager',
        hierarchyRank: 130,
        employeeRole: false,
        cascading: false,
        permissions: [
            Permission.adsConnectionsView,
            Permission.agentsView,
            Permission.birdProxyRead,
            Permission.birdProxyWrite,
            Permission.brandsCampaignDraftsManage,
            Permission.brandsCampaignsManage,
            Permission.businessAccountMembersView,
            Permission.businessAccountsView,
            Permission.channelStrategiesView,
            Permission.contentLibraryManage,
            Permission.contentLibraryView,
            Permission.importerRun,
            Permission.jobCampaignAdvertisementsManage,
            Permission.jobCampaignDraftAdvertisementsManage,
            Permission.jobCampaignDraftsManage,
            Permission.jobCampaignsManage,
            Permission.jobylonManageSingleTalents,
            Permission.leadsJourneyAutomationsManage,
            Permission.leadsJourneysManage,
            Permission.leadsTalentpoolsManage,
            Permission.microserviceProxyAccess,
            Permission.productItemsView,
            Permission.productsView,
            Permission.talentsManage,
            Permission.talentsRemove,
            Permission.websiteWidgetsView,
        ],
    },
    {
        id: 'campaign_manager_no_content',
        displayName: 'Campaign Manager (no content)',
        hierarchyRank: 140,
        employeeRole: false,
        cascading: false,
        permissions: [
            Permission.adsConnectionsView,
            Permission.agentsView,
            Permission.birdProxyRead,
            Permission.brandsCampaignDraftsManage,
            Permission.brandsCampaignsManage,
            Permission.businessAccountMembersView,
            Permission.businessAccountsView,
            Permission.channelStrategiesView,
            Permission.contentLibraryView,
            Permission.importerRun,
            Permission.jobCampaignDraftsManage,
            Permission.jobCampaignsManage,
            Permission.jobylonManageSingleTalents,
            Permission.microserviceProxyAccess,
            Permission.productItemsView,
            Permission.productsView,
            Permission.talentsManage,
            Permission.websiteWidgetsView,
        ],
    },
    {
        id: 'campaign_planner',
        displayName: 'Campaign Planner',
        hierarchyRank: 150,
        employeeRole: false,
        cascading: false,
        permissions: [
            Permission.adsConnectionsView,
            Permission.agentsView,
            Permission.birdProxyRead,
            Permission.brandsCampaignDraftsManage,
            Permission.businessAccountMembersView,
            Permission.businessAccountsView,
            Permission.channelStrategiesView,
            Permission.contentLibraryView,
            Permission.importerRun,
            Permission.jobCampaignDraftAdvertisementsManage,
            Permission.jobCampaignDraftsManage,
            Permission.jobylonManageSingleTalents,
            Permission.microserviceProxyAccess,
            Permission.productItemsView,
            Permission.productsView,
            Permission.talentsManage,
            Permission.websiteWidgetsView,
        ],
    },
    {
        id: 'campaign_planner_no_content',
        displayName: 'Campaign Planner (no content)',
        hierarchyRank: 160,
        employeeRole: false,
        cascading: false,
        permissions: [
            Permission.adsConnectionsView,
            Permission.agentsView,
            Permission.birdProxyRead,
            Permission.brandsCampaignDraftsManage,
            Permission.businessAccountMembersView,
            Permission.businessAccountsView,
            Permission.channelStrategiesView,
            Permission.contentLibraryView,
            Permission.importerRun,
            Permission.jobCampaignDraftsManage,
            Permission.jobylonManageSingleTalents,
            Permission.microserviceProxyAccess,
            Permission.productItemsView,
            Permission.productsView,
            Permission.talentsManage,
            Permission.websiteWidgetsView,
        ],
    },
    {
        id: 'read_only_user',
        displayName: 'Read-only User',
        hierarchyRank: 180,
        employeeRole: false,
        cascading: false,
        permissions: [
            Permission.adsConnectionsView,
            Permission.agentsView,
            Permission.birdProxyRead,
            Permission.businessAccountMembersView,
            Permission.businessAccountsView,
            Permission.channelStrategiesView,
            Permission.contentLibraryView,
            Permission.productItemsView,
            Permission.productsView,
            Permission.websiteWidgetsView,
        ],
    },
    {
        id: 'no_access',
        displayName: 'No access',
        hierarchyRank: 10000,
        employeeRole: false,
        cascading: true,
        permissions: [],
    },
];
